import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-budget-total',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './budget-total.component.html',
  styleUrls: ['./budget-total.component.scss'],
})
export class BudgetTotalComponent {
  hasOnlinePayment = input.required<boolean>();
  total = input.required<string>();
  oldTotal = input.required<string>();
  totalSubtitle = input<string>('');
}
